import TagsField from './TagsField.wrapper';
import { ITagsField } from './TagsField.interfaces';

export default TagsField;
export { TagsField, ITagsField };
